import * as React from "react";
import { Navigate, useRoutes } from "react-router-dom";

import HomepageLayout from "./Layouts/Homepage";
import Home from "./Pages/Home";
import WhyWeBuilt from "./Pages/WhyWeBuilt";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import NewsLetter from "./Pages/Newsletter";

function Router() {
  let element = useRoutes([
    {
      path: "/",
      element: <HomepageLayout />,
      children: [
        { path: "", element: <Home /> },
        { path: "/privacy-policy", element: <PrivacyPolicy /> },
        { path: "/newsletter", element: <NewsLetter /> },

        { path: "/about", element: <WhyWeBuilt /> },
        { path: "/acacia", element: <Home /> },
        // Retired URLs (e.g. /success-stories, /careers, /blog) land home rather than blank
        { path: "*", element: <Navigate to="/" replace /> },
      ],
    },
  ]);
  return element;
}

export default Router;
